import { render } from "./AppCover.vue?vue&type=template&id=6218eabe&ts=true"
import script from "./AppCover.vue?vue&type=script&lang=ts"
export * from "./AppCover.vue?vue&type=script&lang=ts"

import "./AppCover.vue?vue&type=style&index=0&id=6218eabe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__